import moment from "moment";

export class InterviewSummary {
  title: string = "";
  description: string = "";
  surveyRequestId: string = "";
  brand: string = "";
  completedDate: string = "";
  customerName: string = "";
  dataSurvey: string | Date = "";
  dealer: string = "";
  dealerName: string = "";
  market: string = "";
  outlet?: string = "";
  region: string = "";
  rpStatus: string = "";
  rpDtStatus: String | "";
  vin: string = "";
  dateEnd: string = "";
  model: string = "";
  engine: string = "";
  channel: string = "";
  responseFlag: string = "";
  interviewdate: string = "";
  modelComputed: string = "";
  alertRaised: string = "";
  agentName: string = "";
  anonimityRelease: string = "";


  disabled: boolean;
  Privacy?: any;
  downloadDetail?: boolean = false;
  constructor(domainInterview: any) {
    delete domainInterview.outlet;
    delete domainInterview.brandName;
    delete domainInterview.answers;

    Object.assign(this, domainInterview);
    this.disabled = domainInterview.rpCreateBtn === "0" || false;
    this.rpDtStatus = this.humanize(domainInterview.rpDtStatus);
    this.rpStatus = domainInterview.rpStatus;
    this.interviewdate = domainInterview.completedDate
    this.modelComputed = domainInterview.model
    this.alertRaised = domainInterview.hotAlert

  }

  private humanize(timestamp: number | string) {

    if (timestamp && timestamp !== "not valid" && timestamp !== "valid") {
      var duration = moment.duration(timestamp, 'milliseconds');
      var days = duration.humanize();
      return days;
    } else {
      return "";
    }
  }
}
